import { SignInBrandLogo, useBranding } from '@l2u/web-shared';
import { supportEmailOf } from '@l2u/shared/brandingDefaults';

/**
 * A company whose compliance questionnaire passed its deadline unsubmitted.
 *
 * Reached only AFTER identity is proven — a verified sign-in code, a signed
 * invitation link, or a live session the api refused with `account_locked` —
 * so nothing here tells a stranger whether an address exists. There is
 * deliberately no "email me a new sign-in link" button: a new link would sign
 * straight back into the same lock. Only an administrator's unlock ends it.
 */
export function CompanyLocked() {
  const { branding } = useBranding();
  const supportEmail = supportEmailOf(branding);
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <SignInBrandLogo align="center" className="mb-3" />
        <h1 className="mt-2 text-lg font-semibold text-slate-900">Your account is locked</h1>
        <p className="mt-2 text-sm text-slate-600">
          A compliance questionnaire we sent you wasn’t submitted by its deadline, so access to the
          portal has been paused. Contact your administrator to unlock your account — they’ll reset
          the deadline so you can complete it.
        </p>
        <p className="mt-5 text-sm text-slate-500">
          Need help? Email{' '}
          <a href={`mailto:${supportEmail}`} className="text-blue-600 hover:underline">
            {supportEmail}
          </a>
          .
        </p>
      </div>
    </div>
  );
}
